import { GenericAbortSignal } from "axios";
import api from "PFCore/api";
import { Engagement, Id, PaginatedCollection, QueryParams } from "PFTypes";

export type FetchEngagementsPayload = QueryParams<{
  id?: number[];
  term?: string;
  state?: string[];
  ownerId?: Id;
}>;

export type EngagementResponseItem = { activity: Engagement; id: number };

export type FetchEngagementsResponse = PaginatedCollection<EngagementResponseItem[]>;

export const fetchEngagements = (
  params: FetchEngagementsPayload,
  { signal }: { signal?: GenericAbortSignal }
): Promise<FetchEngagementsResponse> =>
  api({
    url: "engagements",
    params,
    signal
  });
